import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Nav from '../../../shared/components/Nav';
import { MENU_CUSTOMER_SERVICE_CENTER } from '../../../shared/constants/app';
import PopupPAHAB010Tab1 from './popupPAHAB010Tab1';
import PopupPAHAB010Tab2 from './popupPAHAB010Tab2';
import { getPAGAA000, getPAHAB010 } from '../../../services/Api';
import { formatNumberWithCommas, updateMenuVisibility } from '../../../utils';
import GoodsPriceRow, { GOODS_CODE, toGoodsMap } from './GoodsPriceRow';

const PAHAB010 = () => {
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [isPopupOpenTab1, setIsPopupOpenTab1] = useState(false);
    const [isPopupOpenTab2, setIsPopupOpenTab2] = useState(false);
    const [customerServiceMenu, setCustomerServiceMenu] = useState([]);
    const [goodsMap, setGoodsMap] = useState({});

    const handleTabChange = useCallback((index) => {
        setActiveTabIndex(index);
    }, []);

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedCustomerServiceMenu = updateMenuVisibility(data, MENU_CUSTOMER_SERVICE_CENTER);
                setCustomerServiceMenu(updatedCustomerServiceMenu);
            })
            .catch((error) => console.log(error));

        // Tên, giá, thời hạn sản phẩm lấy từ tblGoods_Master / tblGoods_Price
        getPAHAB010()
            .then(({ data }) => setGoodsMap(toGoodsMap(data)))
            .catch((error) => console.log(error));
    }, []);

    const openPopup = (popupTab) => {
        popupTab(true);
    };
    const closePopup = (popupTab) => {
        popupTab(false);
    };

    const getTermDaysText = (goodCode) =>
        goodsMap[goodCode]?.termDays ? `이용기간: ${goodsMap[goodCode].termDays}일` : '';

    const recruitNews = goodsMap[GOODS_CODE.RECRUIT_NEWS];
    return (
        <>
            <div id="content">
                <Nav menu={customerServiceMenu} />
                <div id="recruitment-adv">
                    <div className="container">
                        <div className="top-form">
                            <h2>채용광고 상품안내</h2>
                        </div>
                        <ul className="tabs short-tab blue">
                            <li>
                                <Link
                                    className={`ver2 left ${activeTabIndex === 0 && 'active'}`}
                                    onClick={() => handleTabChange(0)}
                                >
                                    덴탈잡 홈(메인) 메뉴
                                </Link>
                            </li>
                            <li>
                                <Link
                                    className={`ver2 right ${activeTabIndex === 1 && 'active'}`}
                                    onClick={() => handleTabChange(1)}
                                >
                                    채용정보 메뉴
                                </Link>
                            </li>
                        </ul>
                        <div className="tab-items">
                            {activeTabIndex === 0 && (
                                <div className="tab-item active">
                                    <div className="ticket">
                                        <ul className="tab-list-desc">
                                            <li>
                                                ＊모든 상품은 1회 비용이며, 서비스 기간 중간에 채용마감을 하시면 남은
                                                기간은 소멸됩니다.
                                            </li>
                                            <li>
                                                ＊상품 신청일과 결제일이 동일한 일자일 경우 신청일자부터 공고 1일 째가
                                                됩니다.
                                            </li>
                                            <li>
                                                ＊옵션 및 강조 상품은 해당 공고 기간 내에서만 서비스가 가능하며, 공고
                                                종료일을 초과할 수 없습니다.
                                            </li>
                                            <li>
                                                ＊온라인 상품의 특성상 한번 게재되면 상품을 사용하신 것으로 간주되어
                                                환불이 어려우니, 신중하게 신청해주시면 감사하겠습니다.
                                            </li>
                                        </ul>
                                        <div className="ticket__btbx">
                                            <button
                                                type="button"
                                                className="ticket__btn ticket__btn--red"
                                                onClick={() => {
                                                    window.open(
                                                        'https://www.dvmall.co.kr/search-result?query=%EB%8D%B4%ED%83%88%EC%9E%A1%20%EC%9D%B4%EC%9A%A9%EA%B6%8C&page=1&searchType=0',
                                                        '_blank',
                                                    );
                                                }}
                                            >
                                                DVmall<span>[덴탈잡 이용권]</span>
                                            </button>
                                            <button
                                                type="button"
                                                className="ticket__btn"
                                                onClick={() => {
                                                    openPopup(setIsPopupOpenTab1);
                                                }}
                                            >
                                                가격표 보기
                                            </button>
                                        </div>
                                    </div>
                                    <div className="tab-content">
                                        <ul className="ticket__list">
                                            <li className="ticket__item">
                                                <img
                                                    className="ticket__img"
                                                    src="./images/PAHAB010/image-sample1.png"
                                                    alt="sample1"
                                                />
                                                <div className="ticket__block">
                                                    <div className="ticket__head">
                                                        <div className="ticket__lf">
                                                            <h3 className="ticket__tit">
                                                                <span>1</span>
                                                                비즈니스 배너
                                                            </h3>
                                                            <div className="ticket__desc">
                                                                <span>
                                                                    노출위치: 메인페이지 상단 3개 배너(그랜드 배너
                                                                    세로2칸 영역)
                                                                </span>
                                                                <span>추가 서비스: 채용정보 상품 서비스</span>
                                                                <span>이용대상: 치과병(의)원</span>
                                                            </div>
                                                        </div>
                                                        <div className="ticket__rt">
                                                            {getTermDaysText(GOODS_CODE.BUSINESS_BANNER)}
                                                        </div>
                                                    </div>
                                                    <div className="ticket__table">
                                                        <div className="ticket__grid ticket__grid--head">
                                                            <span>광고 상품 / 덴탈잡 이용권</span>
                                                            <span>덴탈잡</span>
                                                            <span>DVmall</span>
                                                            <span>DVmall 멤버십</span>
                                                        </div>
                                                        <GoodsPriceRow goods={goodsMap[GOODS_CODE.BUSINESS_BANNER]} />
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="ticket__item">
                                                <img
                                                    className="ticket__img"
                                                    src="./images/PAHAB010/image-sample2.png"
                                                    alt="sample2"
                                                />
                                                <div className="ticket__block">
                                                    <div className="ticket__head">
                                                        <div className="ticket__lf">
                                                            <h3 className="ticket__tit ticket__tit--sky">
                                                                <span>2</span>
                                                                그랜드 배너
                                                            </h3>
                                                            <div className="ticket__desc">
                                                                <span>
                                                                    노출위치: 메인페이지 상단, 채용정보 모든 서브 페이지
                                                                </span>
                                                                <span>추가 서비스: 채용정보 상품 서비스</span>
                                                                <span>이용대상: 치과병(의)원</span>
                                                            </div>
                                                        </div>
                                                        <div className="ticket__rt">
                                                            {getTermDaysText(GOODS_CODE.GRAND_BANNER)}
                                                        </div>
                                                    </div>
                                                    <div className="ticket__table">
                                                        <div className="ticket__grid ticket__grid--head">
                                                            <span>광고 상품 / 덴탈잡 이용권</span>
                                                            <span>덴탈잡</span>
                                                            <span>DVmall</span>
                                                            <span>DVmall 멤버십</span>
                                                        </div>
                                                        <GoodsPriceRow goods={goodsMap[GOODS_CODE.GRAND_BANNER]} />
                                                        <GoodsPriceRow goods={goodsMap[GOODS_CODE.GRAND_BANNER_FIXED]} />
                                                        {/* <div className="ticket__grid">
                                                            <span className="left">
                                                                <span>
                                                                    그랜드 배너
                                                                    <br />
                                                                    <i>+채용광고 디자인 서비스</i>
                                                                </span>
                                                            </span>
                                                            <span>-</span>
                                                            <span>
                                                                <b>400,000</b>원
                                                            </span>
                                                        </div> */}
                                                    </div>
                                                    <p className="ticket__ps">
                                                        ※ DVmall에서 그랜드배너 구매 시, 채용광고 디자인 서비스를 함께
                                                        구매하실 수 있습니다.
                                                    </p>
                                                    <div className="ticket__add">
                                                        <div className="ticket__add-txt">
                                                            [추가상품]
                                                            <br />※ 그랜드 배너-고정옵션
                                                        </div>
                                                        <div className="ticket__desc">
                                                            <span>
                                                                노출위치: 모든 그랜드 배너 영역의 상단 부분에 고정으로
                                                                노출
                                                            </span>
                                                            <span>
                                                                기간: 그랜드 배너 게재 일자와 동일한 기간에 사용가능
                                                            </span>
                                                            <span>
                                                                이용조건: 그랜드 배너 상품을 선택하신 후에 추가로 이용할
                                                                수 있는 상품입니다.
                                                            </span>
                                                            <span className="sky" style={{ wordBreak: 'keep-all' }}>
                                                                좌측 이미지는 예시 이미지로 실제 고정옵션의 갯수는
                                                                제한이 없으며, 신청하신 순서에 따라 신청 건수 모두
                                                                게재됩니다.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="ticket__item">
                                                <img
                                                    className="ticket__img"
                                                    src="./images/PAHAB010/image-sample3.png"
                                                    alt="sample3"
                                                />
                                                <div className="ticket__block">
                                                    <div className="ticket__head">
                                                        <div className="ticket__lf">
                                                            <h3 className="ticket__tit ticket__tit--green">
                                                                <span>3</span>
                                                                프리미엄 배너
                                                            </h3>
                                                            <div className="ticket__desc">
                                                                <span>노출위치: 메인페이지 그랜드 배너 아래 위치</span>
                                                                <span>추가 서비스: 채용정보 상품 서비스</span>
                                                                <span>이용대상: 치과병(의)원</span>
                                                            </div>
                                                        </div>
                                                        <div className="ticket__rt">
                                                            {getTermDaysText(GOODS_CODE.PREMIUM_BANNER)}
                                                        </div>
                                                    </div>
                                                    <div className="ticket__table">
                                                        <div className="ticket__grid ticket__grid--head">
                                                            <span>광고 상품 / 덴탈잡 이용권</span>
                                                            <span>덴탈잡</span>
                                                            <span>DVmall</span>
                                                            <span>DVmall 멤버십</span>
                                                        </div>
                                                        <GoodsPriceRow goods={goodsMap[GOODS_CODE.PREMIUM_BANNER]} />
                                                        <GoodsPriceRow goods={goodsMap[GOODS_CODE.PREMIUM_BANNER_FIXED]} />
                                                        {/* <div className="ticket__grid">
                                                            <span className="left">
                                                                <span>
                                                                    프리미엄 배너
                                                                    <br />
                                                                    <i>+채용광고 디자인 서비스</i>
                                                                </span>
                                                            </span>
                                                            <span>-</span>
                                                            <span>
                                                                <b>360,000</b>원
                                                            </span>
                                                        </div> */}
                                                    </div>
                                                    <p className="ticket__ps">
                                                        ※ DVmall에서 프리미엄배너 2개 구매 시, 채용광고 디자인 서비스를
                                                        무료로 제공받으실 수 있습니다.
                                                    </p>
                                                    <div className="ticket__add">
                                                        <div className="ticket__add-txt">
                                                            [추가상품]
                                                            <br />※ 프리미엄 배너-고정옵션
                                                        </div>
                                                        <div className="ticket__desc">
                                                            <span>
                                                                노출위치: 모든 프리미엄 배너 영역의 상단 부분에 고정으로
                                                                노출
                                                            </span>
                                                            <span>
                                                                기간: 프리미엄 배너 게재 일자와 동일한 기간에 사용가능
                                                            </span>
                                                            <span>
                                                                이용조건: 프리미엄 배너 상품을 선택하신 후에 추가로
                                                                이용할 수 있는 상품입니다.
                                                            </span>
                                                            <span className="sky" style={{ wordBreak: 'keep-all' }}>
                                                                좌측 이미지는 예시 이미지로 실제 고정옵션의 갯수는
                                                                제한이 없으며, 신청하신 순서에 따라 신청 건수 모두
                                                                게재됩니다.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="ticket__item">
                                                <img
                                                    className="ticket__img"
                                                    src="./images/PAHAB010/image-sample4.png"
                                                    alt="sample4"
                                                />
                                                <div className="ticket__block">
                                                    <div className="ticket__head">
                                                        <div className="ticket__lf">
                                                            <h3 className="ticket__tit ticket__tit--cyan">
                                                                <span>4</span>
                                                                기업 배너
                                                            </h3>
                                                            <div className="ticket__desc">
                                                                <span>
                                                                    노출위치: 메인페이지 프리미엄 배너 아래 위치
                                                                </span>
                                                                <span>이용대상: 치과병(의)원이 아닌 일반 기업</span>
                                                            </div>
                                                        </div>
                                                        <div className="ticket__rt">
                                                            {getTermDaysText(GOODS_CODE.COMPANY_BANNER)}
                                                        </div>
                                                    </div>
                                                    <div className="ticket__table">
                                                        <div className="ticket__grid ticket__grid--head">
                                                            <span>광고 상품 / 덴탈잡 이용권</span>
                                                            <span>덴탈잡</span>
                                                            <span>DVmall</span>
                                                            <span>DVmall 멤버십</span>
                                                        </div>
                                                        <GoodsPriceRow goods={goodsMap[GOODS_CODE.COMPANY_BANNER]} />
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="ticket__item">
                                                <img
                                                    className="ticket__img"
                                                    src="./images/PAHAB010/image-sample5.png"
                                                    alt="sample5"
                                                />
                                                <div className="ticket__block">
                                                    <div className="ticket__head">
                                                        <div className="ticket__lf">
                                                            <h3 className="ticket__tit ticket__tit--red">
                                                                <span>5</span>
                                                                핫리쿠르트 배너
                                                            </h3>
                                                            <div className="ticket__desc">
                                                                <span>노출위치: 메인페이지 기업 배너 아래 위치</span>
                                                                <span>추가 서비스: 채용정보 상품 서비스</span>
                                                                <span>이용대상: 치과병(의)원</span>
                                                            </div>
                                                        </div>
                                                        <div className="ticket__rt">
                                                            {getTermDaysText(GOODS_CODE.HOT_RECRUIT_BANNER)}
                                                        </div>
                                                    </div>
                                                    <div className="ticket__table">
                                                        <div className="ticket__grid ticket__grid--head">
                                                            <span>광고 상품 / 덴탈잡 이용권</span>
                                                            <span>덴탈잡</span>
                                                            <span>DVmall</span>
                                                            <span>DVmall 멤버십</span>
                                                        </div>
                                                        <GoodsPriceRow goods={goodsMap[GOODS_CODE.HOT_RECRUIT_BANNER]} />
                                                        <GoodsPriceRow goods={goodsMap[GOODS_CODE.HOT_RECRUIT_BANNER_FIXED]} />
                                                    </div>
                                                    <div className="ticket__add">
                                                        <div className="ticket__add-txt">
                                                            [추가상품]
                                                            <br />※ 핫리쿠르트 배너-고정옵션
                                                        </div>
                                                        <div className="ticket__desc">
                                                            <span>
                                                                노출위치: 모든 핫리쿠르트 배너 영역의 상단 부분에
                                                                고정으로 노출
                                                            </span>
                                                            <span>
                                                                기간: 핫리쿠르트 배너 게재 일자와 동일한 기간에 사용가능
                                                            </span>
                                                            <span>
                                                                이용조건: 핫리쿠르트 배너 상품을 선택하신 후에 추가로
                                                                이용할 수 있는 상품입니다.
                                                            </span>
                                                            <span className="sky" style={{ wordBreak: 'keep-all' }}>
                                                                좌측 이미지는 예시 이미지로 실제 고정옵션의 갯수는
                                                                제한이 없으며, 신청하신 순서에 따라 신청 건수 모두
                                                                게재됩니다.
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            )}
                            {activeTabIndex === 1 && (
                                <div className="tab-item active">
                                    <ul className="ticket__list ticket__list--pt35">
                                        <li className="ticket__item">
                                            <img
                                                className="ticket__img"
                                                src="./images/PAHAB010/image-sample6.png"
                                                alt="sample6"
                                            />
                                            <div className="ticket__block">
                                                <div className="ticket__head">
                                                    <div className="ticket__lf">
                                                        <h3 className="ticket__tit2">
                                                            채용소식
                                                            {recruitNews && (
                                                                <span>
                                                                    ({formatNumberWithCommas(recruitNews.priceDJ)}원/
                                                                    {recruitNews.termDays}일)
                                                                </span>
                                                            )}
                                                        </h3>
                                                        <div className="ticket__desc ticket__desc--pd0">
                                                            <span>노출위치: 채용정보 메뉴 모든 서브 페이지</span>
                                                            <span>이용대상: 치과병(의)원</span>
                                                        </div>
                                                    </div>
                                                    <div className="ticket__btbx">
                                                        <button
                                                            type="button"
                                                            className="ticket__btn ticket__btn--red"
                                                            onClick={() => {
                                                                window.open(
                                                                    'https://www.dvmall.co.kr/search-result?query=%EB%8D%B4%ED%83%88%EC%9E%A1%20%EC%9D%B4%EC%9A%A9%EA%B6%8C&page=1&searchType=0',
                                                                    '_blank',
                                                                );
                                                            }}
                                                        >
                                                            DVmall<span>[덴탈잡 이용권]</span>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="ticket__btn"
                                                            onClick={() => {
                                                                openPopup(setIsPopupOpenTab2);
                                                            }}
                                                        >
                                                            가격표 보기
                                                        </button>
                                                    </div>
                                                </div>
                                                <p className="ticket__ps2">
                                                    <span>
                                                        채용소식은 1회 비용이며, 서비스 기간 중간에 채용마감을 하시면,
                                                        남은 기간은 소멸됩니다.
                                                    </span>
                                                    <span>
                                                        채용소식 신청일과 결제일이 동일한 일자일 경우 신청일자 부터
                                                        채용소식 1일째가 됩니다.
                                                    </span>
                                                </p>
                                                <div className="ticket__add">
                                                    <div className="ticket__add-txt">[추가상품]</div>
                                                    <p className="ticket__ps3">
                                                        위의 기본상품 (배너 또는 채용소식)을 선택하신 후에 추가로 이용할
                                                        수 있는 상품입니다.{' '}
                                                    </p>
                                                    <p className="ticket__ps2 ticket__ps2--mt8">
                                                        <span>
                                                            채용소식은 1회 비용이며, 서비스 기간 중간에 채용마감을
                                                            하시면, 남은 기간은 소멸됩니다.
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="ticket__div">
                                                    <h3 className="ticket__tit3">고정옵션</h3>
                                                    <div className="ticket__smpl yellow">
                                                        <div className="ticket__smpl-lf" style={{ marginTop: '-34px' }}>덴탈잡 치과</div>
                                                        <div className="ticket__smpl-rt">
                                                            <div className="ticket__smpl-tit">
                                                                9호선가양역 3~6년차 진료실 선생님 모십니다.
                                                            </div>
                                                            <ul className="ticket__smpl-list">
                                                                <li>진료실</li>
                                                            </ul>
                                                            <div className="ticket__smpl-lc">
                                                                <div>서울시 &gt; 강서구</div>
                                                                <span className="ticket__smpl-trn">9호선</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="ticket__add">
                                                        <div className="ticket__add-txt">채용소식-고정옵션</div>
                                                        <div className="ticket__desc ticket__desc--pd0">
                                                            <span>
                                                                효과 : 채용정보 메뉴 리스트 첫페이지에 고정 노출, 각
                                                                항목 검색결과 리스트 첫페이지에 고정 노출
                                                            </span>
                                                            <span>
                                                                노출위치 : 채용정보 메뉴 첫페이지, 각 항목 검색결과
                                                                리스트 첫페이지에 고정 노출
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="ticket__table">
                                                        <div className="ticket__grid ticket__grid--head">
                                                            <span>광고 상품 / 덴탈잡 이용권</span>
                                                            <span>덴탈잡</span>
                                                            <span>DVmall</span>
                                                            <span>DVmall 멤버십</span>
                                                        </div>
                                                        <GoodsPriceRow goods={goodsMap[GOODS_CODE.RECRUIT_NEWS_FIXED]} />
                                                        {/* <div className="ticket__grid">
                                                            <span className="left">고정옵션 2주</span>
                                                            <span>
                                                                <b>120,000</b>원
                                                            </span>
                                                            <span>
                                                                <b>100,000</b>원
                                                            </span>
                                                        </div> */}
                                                    </div>
                                                </div>
                                                <div className="ticket__div">
                                                    <h3 className="ticket__tit3">하이라이트 강조</h3>
                                                    <div className="ticket__smpl">
                                                        <div className="ticket__smpl-lf bold">
                                                            <span
                                                                style={{
                                                                    background: '#fbffa1',
                                                                    padding: '3px 0',
                                                                    marginTop: '-36px'
                                                                }}
                                                            >
                                                                덴탈잡 치과
                                                            </span>
                                                        </div>
                                                        <div className="ticket__smpl-rt">
                                                            <div className="ticket__smpl-tit bold" style={{
                                                                width: 'fit-content'
                                                            }}>
                                                                진료실 선생님 모십니다 (매달 인센티브, 주 36시간)
                                                            </div>
                                                            <ul className="ticket__smpl-list">
                                                                <li>진료실</li>
                                                                <li>데스크</li>
                                                                <li>상담</li>
                                                                <li>보험청구</li>
                                                            </ul>
                                                            <div className="ticket__smpl-lc">
                                                                <div>서울시 &gt; 구로구</div>
                                                                <span className="ticket__smpl-trn trn1">1호선</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="ticket__add">
                                                        <div className="ticket__desc ticket__desc--pd0">
                                                            <span>
                                                                효과 : 치과명 + 광고 제목을 굵은 글씨체로 표시하며,
                                                                형광펜 효과로 강조 표시
                                                            </span>
                                                            <span>노출위치 : 채용정보 메뉴 페이지</span>
                                                        </div>
                                                    </div>
                                                    <div className="ticket__table">
                                                        <div className="ticket__grid ticket__grid--head">
                                                            <span>광고 상품 / 덴탈잡 이용권</span>
                                                            <span>덴탈잡</span>
                                                            <span>DVmall</span>
                                                            <span>DVmall 멤버십</span>
                                                        </div>
                                                        <GoodsPriceRow goods={goodsMap[GOODS_CODE.HIGHLIGHT_1W]} />
                                                        <GoodsPriceRow goods={goodsMap[GOODS_CODE.HIGHLIGHT_2W]} />
                                                    </div>
                                                </div>
                                                <div className="ticket__div">
                                                    <h3 className="ticket__tit3">컬러 강조</h3>
                                                    <div className="ticket__smpl">
                                                        <div className="ticket__smpl-lf purple" style={{ marginTop: '-34px' }}>덴탈잡 치과</div>
                                                        <div className="ticket__smpl-rt">
                                                            <div className="ticket__smpl-tit purple">
                                                                (주37시간이하) 최고 대우로 진료실 선생님을 모십니다.
                                                            </div>
                                                            <ul className="ticket__smpl-list">
                                                                <li>진료실</li>
                                                                <li>데스크</li>
                                                                <li>상담</li>
                                                                <li>보험청구</li>
                                                                <li>기타</li>
                                                            </ul>
                                                            <div className="ticket__smpl-lc">
                                                                <div>서울시 &gt; 중랑구</div>
                                                                <span className="ticket__smpl-trn trn7">7호선</span>
                                                                <span className="ticket__smpl-trn trn11">경의중앙</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="ticket__add">
                                                        <div className="ticket__desc ticket__desc--pd0">
                                                            <span>
                                                                효과 : 치과명 + 광고 제목을 굵은 글씨체로 표시하며,
                                                                형광펜 효과로 강조 표시
                                                            </span>
                                                            <span>노출위치 : 채용정보 메뉴 페이지</span>
                                                        </div>
                                                    </div>
                                                    <div className="ticket__table">
                                                        <div className="ticket__grid ticket__grid--head">
                                                            <span>광고 상품 / 덴탈잡 이용권</span>
                                                            <span>덴탈잡</span>
                                                            <span>DVmall</span>
                                                            <span>DVmall 멤버십</span>
                                                        </div>
                                                        <GoodsPriceRow goods={goodsMap[GOODS_CODE.COLOR_1W]} />
                                                        <GoodsPriceRow goods={goodsMap[GOODS_CODE.COLOR_2W]} />
                                                    </div>
                                                </div>
                                                <div className="ticket__div">
                                                    <h3 className="ticket__tit3">아이콘(HOT or 주목)강조</h3>
                                                    <div className="ticket__smpl">
                                                        <div className="ticket__smpl-lf" style={{ marginTop: '-34px' }}>덴탈잡 치과</div>
                                                        <div className="ticket__smpl-rt">
                                                            <div className="ticket__smpl-tit">
                                                                <img src="./images/icons/icon-hot.png" alt="hot" />
                                                                [서울중구/1인기숙사] 경력 치위생사 선생님을 모십니다.
                                                            </div>
                                                            <ul className="ticket__smpl-list">
                                                                <li>진료실</li>
                                                            </ul>
                                                            <div className="ticket__smpl-lc">
                                                                <div>서울시 &gt; 영등포구</div>
                                                                <span className="ticket__smpl-trn trn1">1호선</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="ticket__smpl">
                                                        <div className="ticket__smpl-lf" style={{ marginTop: '-34px' }}>덴탈잡 치과</div>
                                                        <div className="ticket__smpl-rt">
                                                            <div className="ticket__smpl-tit">
                                                                <img src="./images/icons/icon-note.png" alt="note" />
                                                                [서울중구/최고대우] 총괄 실장님을 모십니다.
                                                            </div>
                                                            <ul className="ticket__smpl-list">
                                                                <li>진료실</li>
                                                            </ul>
                                                            <div className="ticket__smpl-lc">
                                                                <div>서울시 &gt; 강남구</div>
                                                                <span className="ticket__smpl-trn trn2">2호선</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="ticket__add">
                                                        <div className="ticket__desc ticket__desc--pd0">
                                                            <span>
                                                                효과 : 채용광고 제목 앞에 붉은색 [HOT] 아이콘이나 초록색
                                                                [주목] 아이콘을 추가하여 강조 표시
                                                            </span>
                                                            <span>노출위치 : 채용정보 메뉴 페이지</span>
                                                        </div>
                                                    </div>
                                                    <div className="ticket__table">
                                                        <div className="ticket__grid ticket__grid--head">
                                                            <span>광고 상품 / 덴탈잡 이용권</span>
                                                            <span>덴탈잡</span>
                                                            <span>DVmall</span>
                                                            <span>DVmall 멤버십</span>
                                                        </div>
                                                        <div className="ticket__grid">
                                                            <span className="left">아이콘 강조 1주</span>
                                                            <span>
                                                                <b>8,000</b>원
                                                            </span>
                                                            <span>
                                                                <b>7,000</b>원
                                                            </span>
                                                            <span>
                                                                <b>6,300</b>원
                                                            </span>
                                                        </div>
                                                        <div className="ticket__grid">
                                                            <span className="left">아이콘 강조 2주</span>
                                                            <span>
                                                                <b>12,000</b>원
                                                            </span>
                                                            <span>
                                                                <b>11,000</b>원
                                                            </span>
                                                            <span>
                                                                <b>9,900</b>원
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {isPopupOpenTab1 && (
                <PopupPAHAB010Tab1 goodsMap={goodsMap} closePopup={() => closePopup(setIsPopupOpenTab1)} />
            )}
            {isPopupOpenTab2 && (
                <PopupPAHAB010Tab2 goodsMap={goodsMap} closePopup={() => closePopup(setIsPopupOpenTab2)} />
            )}
        </>
    );
};

export default PAHAB010;
